import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { uploadImageApi } from '../../api/endpoints';
// Initial state
const initialState = {
  status: '', // loading, success, error
  data: '',
  message: '',
};

// Async thunks for CREATE operations
export const uploadImage = createAsyncThunk('uploadImage', async (payload) => {
  return await uploadImageApi(payload);
});

const uploadImageSlice = createSlice({
  name: 'uploadImage', // Unique Name
  initialState,
  reducers: {
    addUploadReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadImage.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(uploadImage.fulfilled, (state, action) => {
        const { message = '', imagePath = '', payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = imagePath || payload;
      })
      .addCase(uploadImage.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addUploadReset } = uploadImageSlice.actions;

export default uploadImageSlice.reducer;
